import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 1.246A6.75 6.75 0 1 0 14.75 8 6.76 6.76 0 0 0 8 1.246ZM9.28 8.2a.2.2 0 0 0-.25.19v1.9a.2.2 0 0 1-.31.17l-5.3-3.58 3.41.95a.2.2 0 0 0 .25-.2V5.706a.2.2 0 0 1 .31-.16l5.24 3.57Z';
const draw24px =
  'M12,2.246A9.75,9.75,0,1,0,21.75,12,9.763,9.763,0,0,0,12,2.246ZM13.92,12.3a.3.3,0,0,0-.38.29v2.85a.3.3,0,0,1-.47.25l-7.95-5.36,5.12,1.41a.3.3,0,0,0,.38-.29V8.566a.3.3,0,0,1,.47-.25l7.85,5.36Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BoltCircleFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'boltCircleFilled')) as IconWithRender;

BoltCircleFilledIcon.displayName = 'BoltCircleFilledIcon';
BoltCircleFilledIcon.propTypes = Icon.propTypes;
BoltCircleFilledIcon.renderIcon = (props) => (
  <BoltCircleFilledIcon {...props} />
);
export default BoltCircleFilledIcon;
